export const ROLE_SYS_ADMIN = "sys-admin"; // 系統管理員
export const ROLE_ADMIN = "admin"; // 組織管理員
export const ROLE_STAFF = "staff"; // 組織員工

export const ORGANIZATION_VARIABLE = "ORGANIZATION_VARIABLE";
export const ORGANIZATION_VARIABLE_CREATE = "ORGANIZATION_VARIABLE_CREATE"; // 組織參數新增
export const ORGANIZATION_VARIABLE_MODIFY = "ORGANIZATION_VARIABLE_MODIFY"; // 組織參數修改刪除
export const ORGANIZATION_MERCHANT_VARIABLE = "ORGANIZATION_MERCHANT_VARIABLE";
export const ORGANIZATION_MERCHANT_TEMPLATE = "ORGANIZATION_MERCHANT_TEMPLATE";
export const ORGANIZATION_MERCHANT_VARIABLE_CREATE =
  "ORGANIZATION_MERCHANT_VARIABLE_CREATE"; // 通路參數新增
export const ORGANIZATION_MERCHANT_VARIABLE_MODIFY =
  "ORGANIZATION_MERCHANT_VARIABLE_MODIFY"; // 通路參數修改刪除
export const ORGANIZATION_LIST_VIEW = "ORGANIZATION_LIST_VIEW";
export const ORGANIZATION_MODIFY = "ORGANIZATION_MODIFY";
export const ORGANIZATION_DELETE = "ORGANIZATION_DELETE";

export const MERCHANT_LIST_VIEW = "MERCHANT_LIST_VIEW";
export const MERCHANT_MODIFY = "MERCHANT_MODIFY";
export const MERCHANT_DELETE = "MERCHANT_DELETE";

export const STAFF_LIST_VIEW = "STAFF_LIST_VIEW"; // 帳號清單、查看帳號內容
export const STAFF_LIST_VIEW_ALL_BRANCH = "STAFF_LIST_VIEW-ALL_BRANCH"; // 可以看所有分店的帳號
export const STAFF_LIST_VIEW_NO_BRANCH = "STAFF_LIST_VIEW-NO_BRANCH"; // 可以看沒有 branch 的帳號
export const STAFF_LIST_VIEW_SAME_LEVEL = "STAFF_LIST_VIEW-SAME_LEVEL"; // 可以看權重與自己同等級的角色
export const STAFF_CREATE = "STAFF_CREATE"; // 新增帳號
export const STAFF_IMPORT = "STAFF_IMPORT"; // 批次上傳帳號
export const STAFF_MODIFY = "STAFF_MODIFY"; // 修改帳號
export const STAFF_BRANCH_MODIFY = "STAFF_BRANCH_MODIFY"; // 設定帳號分店
export const STAFF_ROLE_MODIFY = "STAFF_ROLE_MODIFY"; // 設定帳號角色
export const STAFF_DELETE = "STAFF_DELETE"; // 刪除帳號
export const STAFF_CHANGE_PASSWORD = "STAFF_CHANGE_PASSWORD"; // 變更帳號密碼
export const STAFF_UNLOCK = "STAFF_UNLOCK"; // 帳號登入解鎖
export const STAFF_CUSTOMER_VIEW = "STAFF_CUSTOMER_VIEW"; // 客戶綁定清單
export const EXPORT_STAFF_SPECIFIC_URI = "EXPORT_STAFF_SPECIFIC_URI" // 可以匯出綁定連結與 QRCode

export const GROUP_LIST_VIEW_1 = "GROUP_LIST_VIEW_1"; // 群組列表(狀態：正常)
export const GROUP_LIST_VIEW_2 = "GROUP_LIST_VIEW_2"; // 群組列表(狀態：未完成)
export const GROUP_LIST_VIEW_3 = "GROUP_LIST_VIEW_3"; // 群組列表(狀態：已退出)

export const GROUP_VIEW_DETAIL = "GROUP_VIEW_DETAIL"; // 動作 A：查看七天內對話紀錄、查看群組用戶名單
export const GROUP_EDIT_LINK = "GROUP_EDIT_LINK"; // 動作 B：編輯群組連結
export const GROUP_DELETE_LOGS = "GROUP_DELETE_LOGS"; // 動作 C：刪除群組紀錄
export const GROUP_EDIT_BRANCH = "GROUP_EDIT_BRANCH"; // 動作 D：編輯所屬分店
export const GROUP_LEAVE = "GROUP_LEAVE"; // 動作 E：機器人退出群組

export const GUARD_GROUP_LIST_VIEW = "GUARD_GROUP_LIST_VIEW"; // 衛兵群組列表
export const GUARD_GROUP_MODIFY = "GUARD_GROUP_MODIFY"; // 衛兵群組列表設定(設定、重設 OA 群組 黑名單)
export const GUARD_GROUP_SETTING_LIST_VIEW = "GUARD_GROUP_SETTING_LIST_VIEW"; // 衛兵群組保護設定（檢視）
export const GUARD_GROUP_SETTING_MODIFY = "GUARD_GROUP_SETTING_MODIFY"; // 衛兵群組保護設定（變更）
export const GUARD_MEMBER_LIST_VIEW = "GUARD_MEMBER_LIST_VIEW"; // 衛兵群組成員名單設定（檢視）
export const GUARD_BLACK_GLOBAL_MODIFY = "GUARD_BLACK_GLOBAL_MODIFY"; // 衛兵群組廣告黑名單設定（變更）
export const GUARD_MEMBER_MODIFY = "GUARD_MEMBER_MODIFY"; // 衛兵群組成員名單設定（變更）
export const GUARD_REPORT_LIST_VIEW = "GUARD_REPORT_LIST_VIEW"; // 衛兵狀態列表
export const GUARD_BELONG_LIST_VIEW = "GUARD_BELONG_LIST_VIEW"; // 衛兵所屬群組

export const NOTIFICATION_LIST = "NOTIFICATION_LIST"; // 通知管理(列表)
export const NOTIFICATION_MODIFY = "NOTIFICATION_MODIFY"; // 新增修改刪除通知
export const NOTIFICATION_MODIFY_CHANGE_BRANCH =
  "NOTIFICATION_MODIFY_CHANGE_BRANCH"; // 通知管理-選擇分店

export const CORE_GROUPBUYING_LIST_VIEW = "CORE_GROUPBUYING_LIST_VIEW"; // CORE-團購列表
export const CORE_GROUPBUYING_MODIFY = "CORE_GROUPBUYING_MODIFY"; // CORE-團購修改、刪除
export const CORE_GROUPBUYING_CREATE = "CORE_GROUPBUYING_CREATE"; // CORE-團購新增
export const CORE_GROUPBUYING_STATUS_MODIFY = "CORE_GROUPBUYING_STATUS_MODIFY"; // CORE-團購狀態設定（結單、流團、暫停收單、完成團購）
export const CORE_GROUPBUYING_LIST_DRAFT = "CORE_GROUPBUYING_LIST_DRAFT"; // CORE-團購狀態設定（結單、流團、暫停收單、完成團購）
export const CORE_GROUPBUYING_LIST_WAITING = "CORE_GROUPBUYING_LIST_WAITING"; // CORE-團購狀態設定（結單、流團、暫停收單、完成團購）
export const CORE_GROUPBUYING_LIST_GOING = "CORE_GROUPBUYING_LIST_GOING"; // CORE-團購狀態設定（結單、流團、暫停收單、完成團購）
export const CORE_GROUPBUYING_LIST_CONFIRMED =
  "CORE_GROUPBUYING_LIST_CONFIRMED"; // CORE-團購狀態設定（結單、流團、暫停收單、完成團購）
export const CORE_GROUPBUYING_LIST_FINISHED = "CORE_GROUPBUYING_LIST_FINISHED"; // CORE-團購狀態設定（結單、流團、暫停收單、完成團購）
export const CORE_GROUPBUYING_LIST_PENDING = "CORE_GROUPBUYING_LIST_PENDING"; // CORE-團購狀態設定（結單、流團、暫停收單、完成團購）
export const CORE_GROUPBUYING_LIST_CANCELED = "CORE_GROUPBUYING_LIST_CANCELED"; // CORE-團購狀態設定（結單、流團、暫停收單、完成團購）
export const CORE_GROUPBUYING_LIST_ARCHIVED = "CORE_GROUPBUYING_LIST_ARCHIVED"; // CORE-團購狀態設定（結單、流團、暫停收單、完成團購）
export const CORE_GROUPBUYING_LIST_DELETED = "CORE_GROUPBUYING_LIST_DELETED"; // CORE-團購狀態設定（結單、流團、暫停收單、完成團購）

export const CORE_GROUPBUYING_PRODUCT_LIST = "CORE_GROUPBUYING_PRODUCT_LIST"; // CORE-團購列表
export const CORE_GROUPBUYING_PRODUCT_MODIFY =
  "CORE_GROUPBUYING_PRODUCT_MODIFY"; // CORE-團購商品修改
export const CORE_GROUPBUYING_PRODUCT_CREATE =
  "CORE_GROUPBUYING_PRODUCT_CREATE"; // CORE-團購商品新增

export const POYA_GROUPBUYINGORDER_SEARCH = "POYA_GROUPBUYINGORDER_SEARCH"; // POYA 顧客訂單查詢
export const GROUPBUYING_LIST_VIEW = "GROUPBUYING_LIST_VIEW"; // 團購列表
export const GROUPBUYING_MODIFY = "GROUPBUYING_MODIFY"; // 我要開團（新增、修改、刪除團購）
export const GROUPBUYING_STATUS_MODIFY = "GROUPBUYING_STATUS_MODIFY"; // 團購狀態設定（結單、流團、暫停收單、完成團購）
export const GROUPBUYING_BLACKLIST = "GROUPBUYING_BLACKLIST"; // 逾期未取名單
export const STORE_GROUPBUYING_CREATE = "STORE_GROUPBUYING_CREATE"; // 門市庫存品開團
export const STORE_GROUPBUYING_DRAFT = "STORE_GROUPBUYING_DRAFT"; // 門市庫存品-草稿
export const GROUPBUYING_BLACKLIST_REVOKE = "GROUPBUYING_BLACKLIST_REVOKE"; // 解除停權（黑名單）
export const GROUPBUYING_SKU_QTY_UPDATE = "GROUPBUYING_SKU_QTY_UPDATE"; // 購買倍數設定
export const GROUPBUYING_ORDER_QTY_UPDATE = "GROUPBUYING_ORDER_QTY_UPDATE"; // 調整團購單數量
export const GROUPBUYING_ORDER_CANCEL = "GROUPBUYING_ORDER_CANCEL"; // 取消團購單

export const MAIN_STORE_GROUPBUYING_CREATE = "MAIN_STORE_GROUPBUYING_CREATE"; // 總公司庫存品團購新增
export const MAIN_GROUPBUYING_LIST_VIEW = "MAIN_GROUPBUYING_LIST_VIEW"; // 總公司團購列表
export const MAIN_GROUPBUYING_CREATE = "MAIN_GROUPBUYING_CREATE"; // 總公司團購新增
export const MAIN_GROUPBUYING_MODIFY = "MAIN_GROUPBUYING_MODIFY"; // 總公司團購編輯、刪除
export const SELECTION_GROUPBUYING_CREATE = "SELECTION_GROUPBUYING_CREATE"; // 總公司選品建立

export const CUSTOMER_LIST_VIEW = "CUSTOMER_LIST_VIEW"; // 會員列表（查看會員內容）
export const CUSTOMER_STAFF_VIEW = "CUSTOMER_STAFF_VIEW"; // 業務綁定清單
export const CUSTOMER_LIST_IMPORT = "CUSTOMER_LIST_IMPORT"; // 顧客資料上傳
export const CUSTOMER_LIST_EDIT = "CUSTOMER_LIST_EDIT"; // 編輯個人資料與擴充欄位
export const CUSTOMER_VIEW = "CUSTOMER_VIEW"; // 會員檢視
export const CUSTOMER_EDIT_UNBIND = "CUSTOMER_EDIT_UNBIND"; // 會員編輯-解除綁定
export const CUSTOMER_EDIT_UNBIND_CLEAR = "CUSTOMER_EDIT_UNBIND_CLEAR"; // 會員編輯-快速解綁
export const CUSTOMER_EDIT_RESET = "CUSTOMER_EDIT_RESET"; // 會員編輯-刪除所有綁定
export const CUSTOMER_EDIT_UNREGISTER = "CUSTOMER_EDIT_UNREGISTER"; // 會員編輯-重新註冊
export const CUSTOMER_EDIT_VERRIFY_PHONE = "CUSTOMER_EDIT_VERRIFY_PHONE"; // 會員編輯-驗證手機
export const CUSTOMER_LINE_SYNC = "CUSTOMER_LINE_SYNC"; // 會員編輯-同步 LINE
export const CUSTOMER_CLEAR_CACHE = "CUSTOMER_CLEAR_CACHE"; // 會員編輯-清除快取
export const CUSTOMER_LIST_TAG_EDIT = "CUSTOMER_LIST_TAG_EDIT"; // 會員編輯-標籤
export const CUSTOMER_DELETE = "CUSTOMER_DELETE"; // 會員 - 刪除
export const CUSTOMER_SOFT_DELETE = "CUSTOMER_SOFT_DELETE"; // 會員 - 軟刪除
export const CUSTOMER_MERGE = "CUSTOMER_MERGE"; // 會員合併

export const CONTACT_LIST_VIEW = "CONTACT_LIST_VIEW"; // 聯絡人列表
export const CONTACT_CREATE = "CONTACT_CREATE"; // 聯絡人建立
export const CONTACT_MODIFY = "CONTACT_MODIFY"; // 聯絡人編輯
export const CONTACT_DELETE = "CONTACT_DELETE"; // 聯絡人刪除

export const BRANCH_LIST_VIEW = "BRANCH_LIST_VIEW"; // 分店列表（含下層）
export const BRANCH_MODIFY = "BRANCH_MODIFY"; // 新增修改分店
export const BRANCH_DELETE = "BRANCH_DELETE"; // 刪除分店
export const BRANCH_DETAIL_CREATE_STAFF = "BRANCH_DETAIL_CREATE_STAFF"; // （店內）新增、批次上傳帳號
export const BRANCH_DETAIL_MODIFY_STAFF = "BRANCH_DETAIL_MODIFY_STAFF"; // （店內）修改帳號
export const BRANCH_DETAIL_DELETE_STAFF = "BRANCH_DETAIL_DELETE_STAFF"; // （店內）刪除帳號
export const BRANCH_DETAIL_VIEW_STAFF = "BRANCH_DETAIL_VIEW_STAFF"; // （店內）檢視帳號
export const BRANCH_DETAIL_CHANGE_PASSWORD = "BRANCH_DETAIL_CHANGE_PASSWORD"; // （店內）變更帳號密碼
export const BRANCH_DETAIL_UNLOCK = "BRANCH_DETAIL_UNLOCK"; // （店內）帳號登入解鎖
export const BRANCH_DETAIL_BOOKING_SHIFT = "BRANCH_DETAIL_BOOKING_SHIFT"; // （店內）預約班表設定
export const BRANCH_TOP_CREATE = "BRANCH_TOP_CREATE"; // 新增最上層分店
export const BRANCH_TOP_VIEW = "BRANCH_TOP_VIEW"; // 顯示最上層分店
export const BRANCH_CREATE = "BRANCH_CREATE"; // 新增非最上層分店
export const BRANCH_DISABLE = "BRANCH_DISABLE"; // 停用非最上層分店
export const BRANCH_TOP_MODIFY = "BRANCH_TOP_MODIFY"; // 修改最上層分店
export const BRANCH_TOP_DELETE = "BRANCH_TOP_DELETE"; // 刪除最上層分店
export const BRANCH_TOP_DISABLE = "BRANCH_TOP_DISABLE"; // 停用最上層分店
export const BRANCH_IMPORT_TW_CITY = "BRANCH_IMPORT_TW_CITY"; // 自動產生台灣縣市分區
export const BRANCH_CONFIG_MENU = "BRANCH_CONFIG_MENU"; // 分店圖卡選單編輯

export const CUSTOMER_BRANCH_LIST_VIEW = "CUSTOMER_BRANCH_LIST_VIEW"; // 會員資料底下的分店管理 - 列表
export const CUSTOMER_BRANCH_CREATE = "CUSTOMER_BRANCH_CREATE"; // 會員資料底下的分店管理 - 新增
export const CUSTOMER_BRANCH_EDIT = "CUSTOMER_BRANCH_EDIT"; // 會員資料底下的分店管理 - 編輯

export const ORDER_LIST_VIEW = "ORDER_LIST_VIEW"; // 訂單查看
export const ORDER_CREATE = "ORDER_CREATE"; // 新增訂單
export const ORDER_MODIFY = "ORDER_MODIFY"; // 修改查看
export const ORDER_DELETE = "ORDER_DELETE"; // 刪除訂單
export const ORDER_IMPORT = "ORDER_IMPORT"; // 訂單匯入
export const ORDER_IMPORT_LIGHT = "ORDER_IMPORT_LIGHT"; // 訂單匯入-精簡
export const ORDER_TO_POINT_CALCULATE = "ORDER_TO_POINT_CALCULATE"; // 訂單給點即時運算
export const ORDER_ASSIGN_CUSTOMER = "ORDER_ASSIGN_CUSTOMER"; // 訂單歸戶
export const ORDER_POINT_DELETE = "ORDER_POINT_DELETE"; // 刪除點數紀錄

export const OA_MESSAGE_VIEW = "OA_MESSAGE_VIEW"; // OA 訊息管理
export const OA_PUSH_VIEW = "OA_PUSH_VIEW"; // OA 群發訊息
export const OA_PUSH_CREATE = "OA_PUSH_CREATE"; // OA 群發訊息 - 新增
export const OA_PUSH_MODIFY = "OA_PUSH_MODIFY"; // OA 群發訊息 - 修改
export const OA_PUSH_DELETE = "OA_PUSH_DELETE"; // OA 群發訊息 - 刪除
export const OA_PUSH_VIEW_BRANCH = "OA_PUSH_VIEW_BRANCH"; // OA 群發訊息-分店
export const OA_PUSH_NARROWCAST = "OA_PUSH_NARROWCAST"; // LINE 推播 - 分眾廣播
export const OA_PUSH_VIEW_NO_BRANCH = "OA_PUSH_VIEW_NO_BRANCH"; // OA 群發訊息 - 對組織

export const LINE_MENU_LIST_VIEW = "LINE_MENU_LIST_VIEW"; // 圖文訊息列表
export const LINE_MENU_CREATE = "LINE_MENU_CREATE"; // 圖文訊息新增
export const LINE_MENU_MODIFY = "LINE_MENU_MODIFY"; // 圖文訊息修改
export const LINE_MENU_DELETE = "LINE_MENU_DELETE"; // 圖文訊息刪除

export const PRODUCT_LIST_VIEW = "PRODUCT_LIST_VIEW"; // 商品查看
export const PRODUCT_CREATE = "PRODUCT_CREATE"; // 新增商品
export const PRODUCT_MODIFY = "PRODUCT_MODIFY"; // 修改商品
export const PRODUCT_STOCK_MODIFY = "PRODUCT_STOCK_MODIFY"; // 商品庫存修改
export const PRODUCT_DELETE = "PRODUCT_DELETE"; // 刪除商品
export const PRODUCT_IMPORT = "PRODUCT_IMPORT"; // 商品匯入
export const PRODUCT_IMPORT_MICHELIN = "PRODUCT_IMPORT_MICHELIN"; // 商品匯入 - 米其林
export const PRODUCT_IMPORT_MICHELIN_MB = "PRODUCT_IMPORT_MICHELIN_MB"; // 商品匯入 - 米其林 MB
export const BRANCH_PRODUCT_SYNC = "BRANCH_PRODUCT_SYNC"; // 同步所有分店商品
export const PRODUCT_IMAGE_MODIFY = "PRODUCT_IMAGE_MODIFY"; // 設定商品圖片
export const BRANCH_PRODUCT_STOCK_LIST_VIEW = "BRANCN_PRODUCT_STOCK_LIST_VIEW"; // 分店庫存列表
export const BRANCH_PRODUCT_STOCK_MODIFY = "BRANCN_PRODUCT_STOCK_MODIFY"; // 分店庫存修改
export const BRANCH_PRODUCT_STOCK_MODIFY_NO_BRANCH = "BRANCN_PRODUCT_STOCK_MODIFY_NO_BRANCH"; // 分店庫存修改 - 無隸屬分店

export const BRANCH_PRODUCT_LIST_VIEW = "BRANCH_PRODUCT_LIST_VIEW"; // 分店商品列表
export const BRANCH_PRODUCT_LIST_VIEW_NO_BRANCH = "BRANCH_PRODUCT_LIST_VIEW_NO_BRANCH"; // 分店商品列表 - 無隸屬分店
export const BRANCH_PRODUCT_CREATE = "BRANCH_PRODUCT_CREATE"; // 分店商品新增
export const BRANCH_PRODUCT_MODIFY = "BRANCH_PRODUCT_MODIFY"; // 分店商品修改
export const BRANCH_PRODUCT_DELETE = "BRANCH_PRODUCT_DELETE"; // 分店商品刪除

export const EVENT_LIST_VIEW = "EVENT_LIST_VIEW"; // 活動清單、查看活動內容
export const EVENT_CUSTOMER_LIST_VIEW = "EVENT_CUSTOMER_LIST_VIEW"; // 活動會員清單
export const EVENT_MODIFY = "EVENT_MODIFY"; // 新增、修改、刪除活動
export const MY_NOTIFICATION = "MY_NOTIFICATION"; // 我的通知
export const MY_NOTIFICATION_LATEST = "MY_NOTIFICATION_LATEST"; // 我的最新一則通知
export const MY_CHANGE_PASSWORD = "MY_CHANGE_PASSWORD"; // 變更自己的密碼
export const MY_CHANGE_PROFILE = "MY_CHANGE_PROFILE"; // 變更自己資料
export const MY_STAFF_PROFILE = "MY_STAFF_PROFILE"; // 個人資料設定 (擴充版本)
export const MY_BIND_URI = "MY_BIND_URI"; // 顯示個人綁定連結
export const MY_EXPORT = "MY_EXPORT"; // 顯示資料匯出
export const MY_MANUAL_TASK = "MY_MANUAL_TASK"; // 手動任務狀態
export const MY_SCHEDULED_TASK = "MY_SCHEDULED_TASK"; // 系統執行紀錄
export const MY_SIDEBAR_BRANCH = "MY_SIDEBAR_BRANCH" // 選單顯示分店
export const MY_BOOKING_SHIFT = "MY_BOOKING_SHIFT"; // 預約班表設定
export const SALES_BIND_URI = "SALES_BIND_URI"; // 顯示快速綁定業務連結
export const SALES_SPECIFIC_URI = "SALES_SPECIFIC_URI"; // 業務綁定連結

export const EVENT_PRODUCT_LIST_VIEW = "EVENT_PRODUCT_LIST_VIEW"; // 商品白名單列表、查看
export const EVENT_PRODUCT_CREATE = "EVENT_PRODUCT_CREATE"; // 商品白名單新增
export const EVENT_PRODUCT_MODIFY = "EVENT_PRODUCT_MODIFY"; // 商品白名單修改

// 通路類型
export const MERCHANT_TYPES = {
  DEFAULT_TYPE: "DEFAULT",
  EC_TYPE: "EC",
  LINE_TYPE: "LINE",
  STORE: "STORE",
  EC_91_TYPE: "EC_91",
  GUARD_TYPE: "GUARD",
  POS_TYPE: "POS",
  EC_QDM: "EC_QDM",
  EC_SHOPLINE: "EC_SHOPLINE",
  EC_CYBERBIZ: "EC_CYBERBIZ",
  EC_SAW: "EC_SAW",
  EC_2DFIRE: "EC_2DFIRE",
  POS_ELC: "POS_ELC",
};

export const ROLE_LIST_VIEW = "ROLE_LIST_VIEW"; // 角色查看
export const ROLE_MODIFY = "ROLE_MODIFY"; // 角色查看

export const GROUP_MESSAGE_CREATE = "GROUP_MESSAGE_CREATE"; // 建立群組廣播

export const CHATROOM_TYPE_TYPE_WALTILY = 0; // 聊天室類型
export const CHATROOM_TYPE_TYPE_OA = 1; // 聊天室類型

export const CHATROOM_LIST_VIEW = "CHATROOM_LIST_VIEW"; // 聊天室管理
export const CHATROOM_LIST_CREATE = "CHATROOM_LIST_CREATE"; // 聊天室管理
export const CHATROOM_LIST_MODIFY = "CHATROOM_LIST_MODIFY"; // 聊天室管理
export const CHATROOM_LIST_DELETE = "CHATROOM_LIST_DELETE"; // 聊天室刪除
export const CHATROOM_LIST_OPEN = "CHATROOM_LIST_OPEN"; // 聊天室開關
export const CHATROOM_LIST_VIEW_MSG = "CHATROOM_LIST_VIEW_MSG"; // 聊天室管理
export const CHATROOM_LIST_CHAT_VIEW = "CHATROOM_LIST_CHAT_VIEW"; // 聊天室總覽
export const CHATROOM_LIST_CHAT_REPLY = "CHATROOM_LIST_CHAT_REPLY"; // 聊天室是否可回覆
export const CHATROOM_LIST_CHAT_ORG = "CHATROOM_LIST_CHAT_ORG"; // 顯示整個組織的聊天室
export const CHATROOM_LIST_CHAT_BRANCH_LIST = "CHATROOM_LIST_CHAT_BRANCH_LIST"; //聊天室顯示分店下拉
export const CHATROOM_LIST_CHAT_NOT_SENDER_REPLY =
  "CHATROOM_LIST_CHAT_NOT_SENDER_REPLY"; //聊天室非成員是否可亂入聊天
export const CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE =
  "CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE"; //聊天室成員內容是否可修改
export const CHATROOM_LIST_SHOW_MOBILE_CHATROOM_LINK =
  "CHATROOM_LIST_SHOW_MOBILE_CHATROOM_LINK"; // 顯示手機版連結
export const CHATROOM_LIST_SHOW_SALES_BIND_LINK =
  "CHATROOM_LIST_SHOW_SALES_BIND_LINK"; // 顯示業務啟用連結

export const THEME_GROUPBUYING_LIST_VIEW = "THEME_GROUPBUYING_LIST_VIEW"; // 主題團購列表
export const THEME_GROUPBUYING_CREATE = "THEME_GROUPBUYING_CREATE"; // 主題團購管理新增
export const THEME_GROUPBUYING_MODIFY = "THEME_GROUPBUYING_MODIFY"; // 主題團購管理編輯
export const THEME_GROUPBUYING_LIST_DELETED = "THEME_GROUPBUYING_LIST_DELETED"; // 主題團購管理列表

export const MODULE_LIST_VIEW = "MODULE_LIST_VIEW";
export const MODULE_CREATE = "MODULE_CREATE";
export const MODULE_MODIFY = "MODULE_MODIFY";
export const MODULE_DELETE = "MODULE_DELETE";

export const GIFT_LIST_VIEW = "GIFT_LIST_VIEW"; // 贈品列表
export const GIFT_LIST_CREATE = "GIFT_LIST_CREATE"; // 贈品新增
export const GIFT_LIST_MODIFY = "GIFT_LIST_MODIFY"; // 贈品編輯

export const REDEEM_LIST_VIEW = "REDEEM_LIST_VIEW"; // 換獎紀錄

export const POST_LIST_VIEW = "POST_LIST_VIEW"; // 文章列表
export const POST_LIST_CREATE = "POST_LIST_CREATE"; // 文章建立
export const POST_LIST_MODIFY = "POST_LIST_MODIFY"; // 文章修改

export const REDEEM_CODE_LIST_VIEW = "REDEEM_CODE_LIST_VIEW"; //優惠券列表"
export const REDEEM_CODE_LIST_CREATE = "REDEEM_CODE_LIST_CREATE"; //優惠券建立"
export const REDEEM_CODE_LIST_MODIFY = "REDEEM_CODE_LIST_MODIFY"; //優惠券修改"
export const REDEEM_CODE_LIST_DELETE = "REDEEM_CODE_LIST_DELETE"; //優惠券刪除"
export const REDEEM_CODE_USED_LIST_VIEW = "REDEEM_CODE_USED_LIST_VIEW"; //優惠券使用紀錄
export const REDEEM_CODE_LIST_BRANCH = "REDEEM_CODE_LIST_BRANCH"; // 優惠券列表-選擇分店
export const REDEEM_CODE_LIST_NO_BRANCH = "REDEEM_CODE_LIST_NO_BRANCH"; // 優惠券列表-無分店
export const REDEEM_CODE_LIST_SOFT_DELETE = "REDEEM_CODE_LIST_SOFT_DELETE"; //優惠券軟刪除"
export const REDEEM_CODE_BY_ROLE_CREATE = "REDEEM_CODE_BY_ROLE_CREATE"; //優惠券建立-角色權限"
export const REDEEM_CODE_BY_ROLE_MODIFY = "REDEEM_CODE_BY_ROLE_MODIFY"; //優惠券修改-角色權限"
export const REWARD_CARD_LIST_BRANCH = "REWARD_CARD_LIST_BRANCH"; // 集點卡列表-選擇分店
export const REWARD_CARD_LIST_NO_BRANCH = "REWARD_CARD_LIST_NO_BRANCH"; // 集點卡列表-無分店
export const ORGANIZATION_SUITE_LIST_VIEW = "ORGANIZATION_SUITE_LIST_VIEW"; // 系統方案列表
export const SUITE_CREATE = "SUITE_CREATE"; // 系統方案 - 建立
export const SUITE_MODIFY = "SUITE_MODIFY"; // 系統方案 - 修改
export const SUITE_DELETE = "SUITE_DELETE"; // 系統方案 - 刪除
export const SUITE_PACKAGE_LIST_VIEW = "SUITE_PACKAGE_LIST_VIEW"; // 方案套件 - 列表
export const SUITE_PACKAGE_CREATE = "SUITE_PACKAGE_CREATE"; // 方案套件 - 建立
export const SUITE_PACKAGE_MODIFY = "SUITE_PACKAGE_MODIFY"; // 方案套件 - 修改
export const SUITE_PACKAGE_DELETE = "SUITE_PACKAGE_DELETE"; // 方案套件 - 刪除

export const SHOPLINE_SETTING_QUERY = "SHOPLINE_SETTING_QUERY"; // SHOPLINE 查詢

export const REDEEM_CODE_BUNDLE_TYPES = {
  COUPON: 1,
  LINE_POINT: 2,
};
export const REDEEM_CODE_BUNDLE_TYPE_TRANSLATE = {
  [REDEEM_CODE_BUNDLE_TYPES.COUPON]: "優惠券",
  [REDEEM_CODE_BUNDLE_TYPES.LINE_POINT]: "LINE POINT",
};

export const REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES = {
  NONE: 0,
  PACKAGE: 1,
  FIXED: 2,
  RANDOM: 3,
};

export const REDEEM_CODE_BUNDLE_TAKE_TYPES = {
  DIRECT: 0,
  INPUT_CODE: 1,
  POINT: 2,
  SYSTEM_ASSIGN: 3,
  URL_TAKE: 4,
  LOYALTY_CARD_REDEEM: 5
};

export const REDEEM_CODE_BUNDLE_USAGE_TYPES = {
  IMMEDIATE: 0,  // 立即使用
  NOT_IMMEDIATE: 1, // 無須立即使用
};

export const REDEEM_CODE_BUNDLE_DATELINE_TYPES = {
  CUSTOM: 0,
  BY_TAKE_DATE: 1,
  SAME_AS_TAKE_TIME: 2,
};

export const REDEEM_CODE_BUNDLE_CONFIRM_TYPES = {
  AUTO: 0,
  NONE: 2,
  BRANCH_CODE: 3,
};

export const REDEEM_CODE_BUNDLE_BARCODE_TYPES = {
  CODE_128: 1,
  CODE_39: 2,
  CODE_39_WITH_CHECKSUM: 3,
  PZN: 4,
  EAN_13: 5,
  EAN_8: 6,
  JAN: 7,
  ISBN_13: 8,
  ISBN_10: 9,
  ISSN: 10,
  UPC_A: 11,
};

export const REDEEM_CODE_BUNDLE_RECLAIM_TYPES = {
  RECLAIM_TYPE_DISABLED: 0,
  RECLAIM_TYPE_LIMITED: 1,
  RECLAIM_TYPE_UNLIMITED: 2,
}

export const KEYWORD_LIST_VIEW = "KEYWORD_LIST_VIEW"; // 查看關鍵字
export const KEYWORD_LIST_CREATE = "KEYWORD_LIST_CREATE"; // 新增關鍵字
export const KEYWORD_LIST_MODIFY = "KEYWORD_LIST_MODIFY"; // 刪除關鍵字

export const POYA_AUTOAWARD_VIEW = "POYA_AUTOAWARD_VIEW"; // 查看自動派獎
export const POYA_AUTOAWARD_CREATE = "POYA_AUTOAWARD_CREATE"; // 新增自動派獎
export const POYA_AUTOAWARD_MODIFY = "POYA_AUTOAWARD_MODIFY"; // 修改自動派獎

export const TAG_LIST_VIEW = "TAG_LIST_VIEW"; // 標籤管理
export const TAG_LIST_CREATE = "TAG_LIST_CREATE"; // 標籤管理
export const TAG_LIST_MODIFY = "TAG_LIST_MODIFY"; // 標籤管理

export const POINT_LIST_VIEW = "POINT_LIST_VIEW"; // 點數管理
export const POINT_LIST_CREATE = "POINT_LIST_CREATE"; // 點數管理
export const POINT_LIST_MODIFY = "POINT_LIST_MODIFY"; // 點數修改
export const POINT_LIST_DELETE = "POINT_LIST_DELETE"; // 點數刪除
export const POINT_LOGS_IMPORT = "POINT_LOGS_IMPORT"; // 點數匯入
export const POINT_LIST_DEDUCT = "POINT_LIST_DEDUCT"; // 點數扣除
export const POINT_LOGS_BRANCH = "POINT_LOGS_BRANCH"; // 點數異動 - 選擇分店
export const POINT_LOGS_NO_BRANCH = "POINT_LOGS_NO_BRANCH"; // 點數異動 - 無分店
export const MY_CUSTOMER_LIST = "MY_CUSTOMER_LIST"; // 主控台 - 我的客戶
export const MY_CUSTOMER_LIST_STAFF_TRANSFER =
  "MY_CUSTOMER_LIST_STAFF_TRANSFER"; // 我的客戶 - 業務轉移
export const MY_CUSTOMER_LIST_UNBIND = "MY_CUSTOMER_LIST_UNBIND"; // 我的客戶 - 解除綁定
export const MY_CUSTOMER_LIST_CHANGE_TYPE = "MY_CUSTOMER_LIST_CHANGE_TYPE"; // 我的客戶 - 變更類型

export const SQL_RUNNER_VIEW = "SQL_RUNNER_VIEW"; //SQL 排程檢視
export const SQL_RUNNER_LIST_VIEW = "SQL_RUNNER_LIST_VIEW"; //SQL 排程列表
export const SQL_RUNNER_MODIFY = "SQL_RUNNER_MODIFY"; // SQL 排程建立、編輯
export const SQL_RUNNER_EXECUTE = "SQL_RUNNER_EXECUTE"; // SQL 排程執行
export const MY_REDEEM_CODE_LIST_VIEW = "MY_REDEEM_CODE_LIST_VIEW"; // 我的優惠券
export const MY_DEPT_CUSTOMER_LIST = "MY_DEPT_CUSTOMER_LIST"; // 部門客戶
export const MY_OVERVIEW = "MY_OVERVIEW"; // 系統總覽

export const SHORT_URL_VIEW = "SHORT_URL_VIEW"; // 標籤管理
export const SHORT_URL_CREATE = "SHORT_URL_CREATE"; // 標籤管理
export const SHORT_URL_MODIFY = "SHORT_URL_MODIFY"; // 標籤管理

export const REWARD_CARD_LIST_VIEW = "REWARD_CARD_LIST_VIEW"; // 集點卡列表
export const REWARD_CARD_CREATE = "REWARD_CARD_CREATE"; // 集點卡建立
export const REWARD_CARD_MODIFY = "REWARD_CARD_MODIFY"; // 集點卡編輯
export const REWARD_CARD_DELETE = "REWARD_CARD_DELETE"; // 集點卡刪除
export const REWARD_CARD_ADV_SETTING = "REWARD_CARD_ADV_SETTING"; // 集點卡進階設定
export const REWARD_CARD_EVENT_MODIFY = "REWARD_CARD_EVENT_MODIFY"; // 集點卡活動方式設定權限
export const REWARD_MISSION_LIST_VIEW = "REWARD_MISSION_LIST_VIEW"; // 集點任務列表
export const REWARD_MISSION_CREATE = "REWARD_MISSION_CREATE"; // 集點任務建立
export const REWARD_MISSION_MODIFY = "REWARD_MISSION_MODIFY"; // 集點任務編輯
export const REWARD_MISSION_DELETE = "REWARD_MISSION_DELETE"; // 集點任務刪除
export const REWARD_GIFT_LIST_VIEW = "REWARD_GIFT_LIST_VIEW"; // 集點獎項列表
export const REWARD_GIFT_CREATE = "REWARD_GIFT_CREATE"; // 集點獎項建立
export const REWARD_GIFT_MODIFY = "REWARD_GIFT_MODIFY"; // 集點獎項編輯
export const REWARD_GIFT_DELETE = "REWARD_GIFT_DELETE"; // 集點獎項刪除

export const CUSTOMER_STAFF_TRANSFER = "CUSTOMER_STAFF_TRANSFER"; // 業務模組-業務轉移
export const CUSTOMER_STAFF_CHANGE_TYPE = "CUSTOMER_STAFF_CHANGE_TYPE"; // 業務模組-解除綁定
export const CUSTOMER_STAFF_UNBIND = "CUSTOMER_STAFF_UNBIND"; // 業務模組-變更類型
export const CUSTOMER_STAFF_FILTER_HISTORY = "CUSTOMER_STAFF_FILTER_HISTORY"; // 業務模組-過濾綁定紀錄
export const CUSTOMER_STAFF_FILTER_BOUND_TYPE =
  "CUSTOMER_STAFF_FILTER_BOUND_TYPE"; // 業務模組-過濾綁定類型
export const CUSTOMER_STAFF_FILTER_SEARCH = "CUSTOMER_STAFF_FILTER_SEARCH"; // 業務模組-搜尋欄位
export const CUSTOMER_STAFF_BIND_CUSTOMER = "CUSTOMER_STAFF_BIND_CUSTOMER"; // 業務模組-綁定客戶
export const CUSTOMER_STAFF_BIND_ALL_CUSTOMER = "CUSTOMER_STAFF_BIND_ALL_CUSTOMER"; // 業務模組-綁定全部客戶
export const CUSTOMER_STAFF_BIND_STAFF = "CUSTOMER_STAFF_BIND_STAFF"; // 業務模組-綁定業務

export const INVOICE_LIST_VIEW = "INVOICE_LIST_VIEW"; // 發票管理 - 發票列表

export const POINT_RULE_VIEW = "POINT_RULE_VIEW"; // 入點比例管理 - 入點比例列表
export const POINT_RULE_CREATE = "POINT_RULE_CREATE"; // 入點比例管理 - 入點比例新增
export const POINT_RULE_MODIFY = "POINT_RULE_MODIFY"; // 入點比例管理 - 入點比例修改

export const CUSTOMER_LEVEL_LIST = "CUSTOMER_LEVEL_LIST"; // 會員等級列表
export const CUSTOMER_LEVEL_RECOMPUTE = "CUSTOMER_LEVEL_RECOMPUTE"; // 會員等級計算
export const CUSTOMER_LEVEL_BATCH_RECOMPUTE = "CUSTOMER_LEVEL_BATCH_RECOMPUTE"; // 會員等級批次計算
export const CUSTOMER_LEVEL_CREATE = "CUSTOMER_LEVEL_CREATE"; // 會員等級新增
export const CUSTOMER_LEVEL_EDIT = "CUSTOMER_LEVEL_EDIT"; // 會員等級修改
export const CUSTOMER_LEVEL_DELETE = "CUSTOMER_LEVEL_DELETE"; // 會員等級刪除
export const CUSTOMER_LEVEL_AUTO_CHANGE_VIEW = "CUSTOMER_LEVEL_AUTO_CHANGE_VIEW" // 會員升降查看
export const CUSTOMER_LEVEL_AUTO_CHANGE_EDIT = "CUSTOMER_LEVEL_AUTO_CHANGE_EDIT" // 會員升降查看
export const CUSTOMER_LEVEL_RULE_LIST = "CUSTOMER_LEVEL_RULE_LIST"; // 會員等級條件列表
export const CUSTOMER_LEVEL_RULE_CREATE = "CUSTOMER_LEVEL_RULE_CREATE"; // 會員等級條件新增
export const CUSTOMER_LEVEL_RULE_EDIT = "CUSTOMER_LEVEL_RULE_EDIT"; // 會員等級條件修改
export const CUSTOMER_LEVEL_RULE_DELETE = "CUSTOMER_LEVEL_RULE_DELETE"; // 會員等級條件刪除

export const INVOICE_LOG_LIST_VIEW = "INVOICE_LOG_LIST_VIEW"; // 發票審核 - 發票審核列表
export const INVOICE_LOG_MODIFY = "INVOICE_LOG_MODIFY"; // 發票審核 - 發票審核修改
export const INVOICE_LOG_DELETE = "INVOICE_LOG_DELETE"; // 發票審核 - 發票審核刪除
export const INVOICE_LOG_VERIFY = "INVOICE_LOG_VERIFY"; // 發票審核 - 發票審核

export const INVOICE_CARRIER_VIEW = "INVOICE_CARRIER_VIEW"; // 載具登錄列表

export const LOGS_LIST_VIEW = "LOGS_LIST_VIEW"; // 系統紀錄 - 系統紀錄
export const API_LOGS_LIST_VIEW = "API_LOGS_LIST_VIEW"; // 系統紀錄中心 - API Logs
export const WEBHOOK_EVENTS_LIST_VIEW = "WEBHOOK_EVENTS_LIST_VIEW"; // 系統紀錄中心 - Webhook Events

export const AUDIENCE_LIST_VIEW = "AUDIENCE_LIST_VIEW"; // 受眾管理 - 受眾列表
export const AUDIENCE_CREATE = "AUDIENCE_CREATE"; // 受眾管理 - 受眾新增
export const AUDIENCE_MODIFY = "AUDIENCE_MODIFY"; // 受眾管理 - 受眾修改
export const AUDIENCE_DELETE = "AUDIENCE_DELETE"; // 受眾管理 - 受眾刪出
export const AUDIENCE_LIST_VIEW_BRANCH = "AUDIENCE_LIST_VIEW_BRANCH"; // 受眾管理 - 受眾列表-分店
export const AUDIENCE_SYNC_LINE = "AUDIENCE_SYNC_LINE"; // 受眾管理 - 同步至 LINE
export const AUDIENCE_BRANCH_CREATE = "AUDIENCE_BRANCH_CREATE"; // 受眾管理 - 分店受眾新增
export const AUDIENCE_UPDATE_CUSTOMER = "AUDIENCE_UPDATE_CUSTOMER"; // 受眾管理 - 更新名單

export const AUDIENCE_LIST_VIEW_NO_BRANCH = "AUDIENCE_LIST_VIEW_NO_BRANCH"; // 受眾列表-無分店

export const BADGE_LIST_VIEW = "BADGE_LIST_VIEW"; // 徽章管理 - 徽章列表
export const BADGE_CREATE = "BADGE_CREATE"; // 徽章管理 - 徽章新增
export const BADGE_EDIT = "BADGE_EDIT"; // 徽章管理 - 徽章修改
export const BADGE_DELETE = "BADGE_DELETE"; // 徽章管理 - 徽章刪除

export const DAILY_ACT_LIST_VIEW = "DAILY_ACT_LIST_VIEW"; // 每日活動管理 - 每日活動列表
export const DAILY_ACT_LIST_CREATE = "DAILY_ACT_LIST_CREATE"; // 每日活動管理 - 每日活動新增
export const DAILY_ACT_LIST_MODIFY = "DAILY_ACT_LIST_MODIFY"; // 每日活動管理 - 每日活動修改
export const DAILY_ACT_LIST_DELETE = "DAILY_ACT_LIST_DELETE"; // 每日活動管理 - 每日活動刪除

export const MKT_CONFIG_LIST_VIEW = "MKT_CONFIG_LIST_VIEW"; // 行銷自動化管理 - 行銷自動化列表
export const MKT_CONFIG_LIST_CREATE = "MKT_CONFIG_LIST_CREATE"; // 行銷自動化管理 - 行銷自動化新增
export const MKT_CONFIG_LIST_MODIFY = "MKT_CONFIG_LIST_MODIFY"; // 行銷自動化管理 - 行銷自動化修改
export const MKT_CONFIG_LIST_DELETE = "MKT_CONFIG_LIST_DELETE"; // 行銷自動化管理 - 行銷自動化刪除

export const FILE_LIST_VIEW = "FILE_LIST_VIEW"; // 檔案管理 - 檔案管理列表
export const FILE_CREATE = "FILE_CREATE"; // 檔案管理 - 檔案管理新增
export const FILE_MODIFY = "FILE_MODIFY"; // 檔案管理 - 檔案管理修改
export const FILE_DELETE = "FILE_DELETE"; // 檔案管理 - 檔案管理刪除

export const MKT_RULE_LIST_VIEW = "MKT_RULE_LIST_VIEW"; // 行銷規則管理 - 行銷規則列表
export const MKT_RULE_LIST_CREATE = "MKT_RULE_LIST_CREATE"; // 行銷規則管理 - 行銷規則建立
export const MKT_RULE_LIST_MODIFY = "MKT_RULE_LIST_MODIFY"; // 行銷規則管理 - 行銷規則修改
export const MKT_RULE_LIST_DELETE = "MKT_RULE_LIST_DELETE"; // 行銷規則管理 - 行銷規則刪除

export const PARTNER_LIST_VIEW = "PARTNER_LIST_VIEW"; // 合作夥伴管理 - 夥伴列表
export const PARTNER_CREATE = "PARTNER_CREATE"; // 合作夥伴管理 - 夥伴新增
export const PARTNER_MODIFY = "PARTNER_MODIFY"; // 合作夥伴管理 - 夥伴修改
export const PARTNER_DELETE = "PARTNER_DELETE"; // 合作夥伴管理 - 夥伴刪除

export const PARTNER_WORKER_LIST_VIEW = "PARTNER_WORKER_LIST_VIEW"; // 合作夥伴管理 - 夥伴員工列表
export const PARTNER_WORKER_VERIFY_LIST_VIEW = "PARTNER_WORKER_VERIFY_LIST_VIEW"; // 合作夥伴管理 - 夥伴員工審核列表
export const PARTNER_WORKER_CREATE = "PARTNER_WORKER_CREATE"; // 合作夥伴管理 - 夥伴員工新增
export const PARTNER_WORKER_MODIFY = "PARTNER_WORKER_MODIFY"; // 合作夥伴管理 - 夥伴員工修改
export const PARTNER_WORKER_DELETE = "PARTNER_WORKER_DELETE"; // 合作夥伴管理 - 夥伴員工刪除
export const PARTNER_WORKER_VERIFY = "PARTNER_WORKER_VERIFY"; // 合作夥伴管理 - 夥伴員工審核

export const PARTNER_STAFF_LIST_VIEW = "PARTNER_STAFF_LIST_VIEW"; // 合作夥伴管理 - 夥伴帳號列表
export const PARTNER_STAFF_CREATE = "PARTNER_STAFF_CREATE"; // 合作夥伴管理 - 夥伴帳號新增
export const PARTNER_STAFF_MODIFY = "PARTNER_STAFF_MODIFY"; // 合作夥伴管理 - 夥伴帳號修改
export const PARTNER_STAFF_DELETE = "PARTNER_STAFF_DELETE"; // 合作夥伴管理 - 夥伴帳號刪除

export const TOKEN_LIST_VIEW = "TOKEN_LIST_VIEW"; // Token管理 - TOKEN 檢視
export const TOKEN_CREATE = "TOKEN_CREATE"; // Token管理 - TOKEN 建立
export const TOKEN_MODIFY = "TOKEN_MODIFY"; // Token管理 - TOKEN 編輯
export const TOKEN_DELETE = "TOKEN_DELETE"; // Token管理 - TOKEN 刪除

export const BENEFIT_CARD_LIST_VIEW = "BENEFIT_CARD_LIST_VIEW"; // 權益卡管理 - 檢視
export const BENEFIT_CARD_CREATE = "BENEFIT_CARD_CREATE"; // 權益卡管理 - 建立
export const BENEFIT_CARD_MODIFY = "BENEFIT_CARD_MODIFY"; // 權益卡管理 - 編輯
export const BENEFIT_CARD_DELETE = "BENEFIT_CARD_DELETE"; // 權益卡管理 - 刪除

export const BADGE_CAMPAIGN_LIST_VIEW = "BADGE_CAMPAIGN_LIST_VIEW"; // 徽章活動 - 列表
export const BADGE_CAMPAIGN_CREATE = "BADGE_CAMPAIGN_CREATE"; // 徽章活動 - 新增
export const BADGE_CAMPAIGN_MODIFY = "BADGE_CAMPAIGN_MODIFY"; // 徽章活動 - 修改
export const BADGE_CAMPAIGN_DELETE = "BADGE_CAMPAIGN_DELETE"; // 徽章活動 - 刪除

export const CHECKIN_CAMPAIGN_LIST_VIEW = "CHECKIN_CAMPAIGN_LIST_VIEW"; // 簽到活動 - 列表
export const CHECKIN_CAMPAIGN_CREATE = "CHECKIN_CAMPAIGN_CREATE"; // 簽到活動 - 新增
export const CHECKIN_CAMPAIGN_MODIFY = "CHECKIN_CAMPAIGN_MODIFY"; // 簽到活動 - 修改
export const CHECKIN_CAMPAIGN_DELETE = "CHECKIN_CAMPAIGN_DELETE"; // 簽到活動 - 刪除

export const MGM_CAMPAIGN_LIST_VIEW = "MGM_CAMPAIGN_LIST_VIEW"; // 邀友入會活動 - 列表
export const MGM_CAMPAIGN_CREATE = "MGM_CAMPAIGN_CREATE"; // 邀友入會活動 - 新增
export const MGM_CAMPAIGN_MODIFY = "MGM_CAMPAIGN_MODIFY"; // 邀友入會活動 - 修改
export const MGM_CAMPAIGN_DELETE = "MGM_CAMPAIGN_DELETE"; // 邀友入會活動 - 刪除

export const CHECKIN_MISSION_LIST_VIEW = "CHECKIN_MISSION_LIST_VIEW"; // 簽到任務 - 列表
export const CHECKIN_MISSION_CREATE = "CHECKIN_MISSION_CREATE"; // 簽到任務 - 新增
export const CHECKIN_MISSION_MODIFY = "CHECKIN_MISSION_MODIFY"; // 簽到任務 - 修改
export const CHECKIN_MISSION_DELETE = "CHECKIN_MISSION_DELETE"; // 簽到任務 - 刪除

export const INVOICE_CREATE = "INVOICE_CREATE"; // 發票 - 新增
export const INVOICE_MODIFY = "INVOICE_MODIFY"; // 發票 - 修改
export const INVOICE_DELETE = "INVOICE_DELETE"; // 發票 - 刪除
export const INVOICE_ISSUE = "INVOICE_ISSUE"; // 發票 - 開立
export const INVOICE_CANCEL = "INVOICE_CANCEL"; // 發票 - 作廢

export const HTY_LMS_SETTING_QUERY = "HTY_LMS_SETTING_QUERY"; // 新東陽 查詢
export const HTY_LMS_SETTING_VERIFY_PHONE = "HTY_LMS_SETTING_VERIFY_PHONE"; // 新東陽 查詢
export const HTY_LMS_SETTING_CREATE_ACCOUNT = "HTY_LMS_SETTING_CREATE_ACCOUNT"; // 新東陽 建立會員
export const HTY_LMS_SETTING_DELETE_ACCOUNT = "HTY_LMS_SETTING_DELETE_ACCOUNT"; // 新東陽 註銷會員
export const HTY_FLAPS_SETTING_QUERY = "HTY_FLAPS_SETTING_QUERY"; // 輔翼會員查詢
export const FLAPS_CUSTOMER_LEVEL_CHANGE = "FLAPS_CUSTOMER_LEVEL_CHANGE"; // 輔翼 會員等級批量調整（逐筆同步）

export const MODULE_ORDER_TO_POINTS_MODIFY = "MODULE_ORDER_TO_POINTS_MODIFY"; // 訂單點數設定

export const TWODFIRE_SETTING_QUERY = "2DFIRE_SETTING_QUERY"; // 2DFIRE 查詢
export const BRANCH_CONFIG_SERVICE = "BRANCH_CONFIG_SERVICE"; // 分店設定服務

export const INVOICE_LOG_TYPES = {
  ELECTRONIC: "electronic",
  TRADITIONAL: "traditional",
  ELECTRONIC_CARRIER: "electronic_carrier"
};

export const INVOICE_LOG_STATUS = {
  INIT: "init", // 初始狀態
  E_VERIFY: "e_verify", // 電子 - 審核中
  E_VALID: "e_valid", // 電子 - 審核通過，有效的發票
  E_INVALID: "e_invalid", // 電子 - 不存在
  E_CANCEL: "e_cancel", // 電子 - 已作廢
  T_VERIFY: "t_verify", // 傳統 - 審核中
  T_VALID: "t_valid", // 傳統 - 審核通過，有效的發票
  T_INVALID: "t_invalid", // 傳統 - 不合格
  CANCEL: "cancel", // 人為取消
};

export const RICH_MENU_STATUS = {
  DRAFT: 0, // 草稿
  RESERVE: 1, // 預約
  PUBLISHED: 2, // 已發佈/已傳送
  UNPUBLISHED: 3, // 已下架/已下線
};

export const SERVER_LOG_STATUS_INIT = 0;
export const SERVER_LOG_STATUS_SUCCESS = 1;
export const SERVER_LOG_STATUS_ERROR = -1;

export const SERVER_LOG_STATUSES = {
  [SERVER_LOG_STATUS_SUCCESS]: "成功",
  [SERVER_LOG_STATUS_ERROR]: "失敗",
  [SERVER_LOG_STATUS_INIT]: "未設定",
};

export const SERVER_TASK_LOG_STATUS_PENDING = 0;
export const SERVER_TASK_LOG_STATUS_PROCESSING = 1;
export const SERVER_TASK_LOG_STATUS_SUCCESS = 2;
export const SERVER_TASK_LOG_STATUS_FAILED = -1;

export const SERVER_TASK_LOG_STATUSES = {
  [SERVER_TASK_LOG_STATUS_PENDING]: "等待中",
  [SERVER_TASK_LOG_STATUS_PROCESSING]: "處理中",
  [SERVER_TASK_LOG_STATUS_SUCCESS]: "成功",
  [SERVER_TASK_LOG_STATUS_FAILED]: "失敗",
};

export const SERVER_LOG_TYPE_DEBUG = "0";
export const SERVER_LOG_TYPE_INFO = "1";
export const SERVER_LOG_TYPE_ERROR = "2";
export const SERVER_LOG_TYPE_NOTICE = "3";
export const SERVER_LOG_TYPE_WARNING = "4";
export const SERVER_LOG_TYPE_CRITICAL = "5";
export const SERVER_LOG_TYPE_ALERT = "6";
export const SERVER_LOG_TYPE_EMERGENCY = "7";

export const SERVER_LOG_TYPES = {
  [SERVER_LOG_TYPE_DEBUG]: "DEBUG",
  [SERVER_LOG_TYPE_INFO]: "INFO",
  [SERVER_LOG_TYPE_ERROR]: "ERROR",
  [SERVER_LOG_TYPE_NOTICE]: "NOTICE",
  [SERVER_LOG_TYPE_WARNING]: "WARNING",
  [SERVER_LOG_TYPE_CRITICAL]: "CRITICAL",
  [SERVER_LOG_TYPE_ALERT]: "ALERT",
  [SERVER_LOG_TYPE_EMERGENCY]: "EMERGENCY",
};

export const PUSH_MESSAGE_STATUS = {
  DRAFT: 0, // 草稿
  RESERVE: 1, // 預約
  PUBLISHED: 2, // 已發佈/已傳送
  UNPUBLISHED: 3, // 已下架/已下線
};

export const SIDEBAR_THEMES = {
  THEME_1: "theme_1",
  THEME_2: "theme_2",
  THEME_3: "theme_3",
  THEME_4: "theme_4",
};
export const NEWS_STATUS = {
  DRAFT: 0, // 草稿
  PUBLISHED: 1, // 已發佈
  TAKE_DOWN: 2, // 已下架
};

export const PUBLISH_STATUS = {
  PUBLISHED: 'published', // 已發佈
  DRAFT: 'draft', // 草稿
  CLOSED: 'closed', // 關閉
}

export const SYSTEM_INFO = "SYSTEM_INFO"; //系統參數設定 - 系統資訊
export const LINE_SETTING_MODIFY = "LINE_SETTING_MODIFY"; //系統參數設定 - LINE 參數設定
export const LIFF_CARD_SETTING_MODIFY = "LIFF_CARD_SETTING_MODIFY"; //系統參數設定 - 會員卡畫面
export const LIFF_UI_SETTING_MODIFY = "LIFF_UI_SETTING_MODIFY"; //系統參數設定 - 會員介面設定
export const SHOPLINE_SETTING_MODIFY = "SHOPLINE_SETTING_MODIFY"; //系統參數設定 - SHOPLINE 參數設定
export const LINE_QUERY = "LINE_QUERY"; //系統參數設定 - line查詢

export const MEMBER_EVENT_LIST_VIEW = "MEMBER_EVENT_LIST_VIEW"; //自動化模組 - 會員事件設定 - 列表
export const MEMBER_EVENT_CREATE = "MEMBER_EVENT_CREATE"; //自動化模組 - 會員事件設定 - 新增
export const MEMBER_EVENT_MODIFY = "MEMBER_EVENT_MODIFY"; //自動化模組 - 會員事件設定 - 修改
export const MEMBER_EVENT_DELETE = "MEMBER_EVENT_DELETE"; //自動化模組 - 會員事件設定 - 刪除
export const ACTION_EVENT_LIST_VIEW = "ACTION_EVENT_LIST_VIEW"; //自動化模組 - 活動事件設定
export const SHOPPING_EVENT_LIST_VIEW = "SHOPPING_EVENT_LIST_VIEW"; //自動化模組 - 購物事件設定
export const CUSTOMIZE_EVENT_LIST_VIEW = "CUSTOMIZE_EVENT_LIST_VIEW"; //自動化模組 - 自定義事件
export const MEMBER_LEVEL_EVENT_LIST_VIEW = "MEMBER_LEVEL_EVENT_LIST_VIEW"; //自動化模組 - 會員等級事件設定
export const MEMBER_LEVEL_EVENT_CREATE = "MEMBER_LEVEL_EVENT_CREATE"; //自動化模組 - 會員等級事件設定
export const MEMBER_LEVEL_EVENT_MODIFY = "MEMBER_LEVEL_EVENT_MODIFY"; //自動化模組 - 會員等級事件設定
export const MEMBER_LEVEL_EVENT_DELETE = "MEMBER_LEVEL_EVENT_DELETE"; //自動化模組 - 會員等級事件設定

export const SUITE_SETTING = "SUITE_SETTING" // 方案管理-設定button
export const SUITE_LIST_VIEW = "SUITE_LIST_VIEW" // 方案管理

export const FORM_LIST = "FORM_LIST"; // 表單列表
export const FORM_CREATE = "FORM_CREATE"; // 表單列表
export const FORM_EDIT = "FORM_EDIT"; // 表單編輯
export const FORM_DELETE = "FORM_DELETE"; // 表單刪除
export const FORM_RESULT = "FORM_RESULT"; // 表單結果
export const FORM_APPLY_MODE = "FORM_APPLY_MODE"; // 表單申請模式
export const FORM_EVENT_MODE = "FORM_EVENT_MODE"; // 表單活動模式
export const FORM_SURVEY_MODE = "FORM_SURVEY_MODE"; // 表單問券模式
export const FORM_RESULT_DELETE = "FORM_RESULT_DELETE"; // 填寫資料 - 刪除

export const PARTNER_WORKER_REPORT_LIST = "PARTNER_WORKER_REPORT_LIST" // 報表中心 - 夥伴員工報表

export const COLLECTION_LIST = "COLLECTION_LIST"; // 資料集列表查看
export const COLLECTION_CREATE = "COLLECTION_CREATE"; // 資料集新增
export const COLLECTION_EDIT = "COLLECTION_EDIT"; // 資料集編輯
export const COLLECTION_DELETE = "COLLECTION_DELETE"; // 資料集刪除
export const COLLECTION_ITEM_MANAGE = "COLLECTION_ITEM_MANAGE"; // 資料集項目管理
export const COLLECTION_ITEM_CREATE = "COLLECTION_ITEM_CREATE"; // 資料集內容建立
export const COLLECTION_ITEM_EDIT = "COLLECTION_ITEM_EDIT"; // 資料集內容編輯
export const COLLECTION_ITEM_DELETE = "COLLECTION_ITEM_DELETE"; // 資料集內容刪除
export const COLLECTION_ITEM_MANAGE_BRANCH = "COLLECTION_ITEM_MANAGE_BRANCH"; // 資料集內容-編輯分店
export const COLLECTION_ITEM_LIST_BRANCH = "COLLECTION_ITEM_LIST_BRANCH"; // 資料集內容-分店過濾
export const COLLECTION_ITEM_SYNC_BRANCH = "COLLECTION_ITEM_SYNC_BRANCH"; // 資料集內容-同步至所有分店
export const COLLECTION_ITEM_SYNC_SINGLE_BRANCH = "COLLECTION_ITEM_SYNC_SINGLE_BRANCH"; // 資料集內容-同步至單一分店
export const COLLECTION_ITEM_IMPORT = "COLLECTION_ITEM_IMPORT"; // 資料集內容-匯入
export const BOOKING_PRESET_LIST = "BOOKING_PRESET_LIST"; // 預約設定檔列表
export const BOOKING_PRESET_CREATE = "BOOKING_PRESET_CREATE"; // 預約設定檔新增
export const BOOKING_PRESET_EDIT = "BOOKING_PRESET_EDIT"; // 預約設定檔編輯
export const BOOKING_PRESET_DELETE = "BOOKING_PRESET_DELETE"; // 預約設定檔刪除
export const BOOKING_PRESET_V2_CREATE = "BOOKING_PRESET_V2_CREATE"; // 預約設定檔V2 - 新增
export const BOOKING_PRESET_V2_EDIT = "BOOKING_PRESET_V2_EDIT"; // 預約設定檔V2 - 編輯
export const BOOKING_NORMAL_MODE = "BOOKING_NORMAL_MODE" // 預約設定檔 - 一般模式
export const BOOKING_WIZARD_MODE = "BOOKING_WIZARD_MODE" // 預約設定檔 - 精靈模式

export const BOOKING_LIST = "BOOKING_LIST"; // 預約列表
export const BOOKING_LIST_BRANCH = "BOOKING_LIST_BRANCH"; // 預約列表 - 分店下拉
export const BOOKING_MANAGE_BRANCH = "BOOKING_MANAGE_BRANCH"; // 預約管理 - 編輯分店
export const BOOKING_CREATE = "BOOKING_CREATE"; // 預約新增
export const BOOKING_EDIT = "BOOKING_EDIT"; // 預約編輯
export const BOOKING_DELETE = "BOOKING_DELETE"; // 預約刪除
export const BOOKING_SETTING = "BOOKING_SETTING"; // 預約設定
export const BOOKING_SETTING_DAY_IMPORT = "BOOKING_SETTING_DAY_IMPORT"; // 分店時段匯入
export const BOOKING_BRANCH_NOTIFICATION_SETTING = "BOOKING_BRANCH_NOTIFICATION_SETTING"; // 預約設定 - 分店通知

export const BOOKING_BRANCH_SETTING_MODIFY = "BOOKING_BRANCH_SETTING_MODIFY"; // 預約設定 - 基本資料

export const BOOKING_CALENDAR = "BOOKING_CALENDAR"; // 預約日曆
export const BOOKING_OVERVIEW = "BOOKING_OVERVIEW"; // 預約總覽
export const BOOKING_LIST_VIEW = "BOOKING_LIST_VIEW"; // 預約列表查看
export const BOOKING_LIST_QUOTATION_SETTING = "BOOKING_LIST_QUOTATION_SETTING" // 預約管理-估價單設定
export const BOOKING_LIST_QUOTATION = "BOOKING_LIST_QUOTATION" // 預約管理-估價單
export const BOOKING_QUOTATION_TO_INVOICE = "BOOKING_QUOTATION_TO_INVOICE" // 預約管理-估價單開發票

export const BOOKING_BRANCH_SHIFT_LIST_VIEW = "BOOKING_BRANCH_SHIFT_LIST_VIEW"; // 預約設定 - 店休列表
export const BOOKING_BRANCH_SHIFT_CREATE = "BOOKING_BRANCH_SHIFT_CREATE"; // 預約設定 - 店休建立
export const BOOKING_BRANCH_SHIFT_MODIFY = "BOOKING_BRANCH_SHIFT_MODIFY"; // 預約設定 - 店休編輯
export const BOOKING_BRANCH_SHIFT_DELETE = "BOOKING_BRANCH_SHIFT_DELETE"; // 預約設定 - 店休刪除

export const TAKOPOS_SETTING_MODIFY = "2DFIRE_SETTING_MODIFY";
export const POSPAL_SETTING_MODIFY = "POSPAL_SETTING_MODIFY";

export const PREORDER_SETTING_LIST = "PREORDER_SETTING_LIST"; // 預購設定列表
export const PREORDER_SETTING_CREATE = "PREORDER_SETTING_CREATE"; // 預購設定新增
export const PREORDER_SETTING_MODIFY = "PREORDER_SETTING_MODIFY"; // 預購設定修改
export const PREORDER_SETTING_DELETE = "PREORDER_SETTING_DELETE"; // 預購設定刪除
export const PREORDER_SETTING_ADVANCE = "PREORDER_SETTING_ADVANCE"; // 預購設定-進階
export const PREORDER_LIST_VIEW = "PREORDER_LIST_VIEW"; // 預購單列表查看
export const PREORDER_BRANCH_VIEW = "PREORDER_BRANCH_VIEW"; // 預購訂單分店列表
export const PREORDER_VIEW = "PREORDER_VIEW"; // 預選單全部查看
export const PREORDER_DELETE = "PREORDER_DELETE"; // 預購訂單 - 刪除
export const PREORDER_STATUS_MODIFY = "PREORDER_STATUS_MODIFY"; // 預購訂單狀態修改

export const BODYSHOP_SETTING_QUERY = "BODYSHOP_SETTING_QUERY"; // BodyShop 查詢
export const ELC_SETTING_QUERY = "ELC_SETTING_QUERY"; // ELC 查詢
export const CYBERBIZ_SETTING_QUERY = "CYBERBIZ_SETTING_QUERY"; // Cyberbiz 查詢
export const CYBERBIZ_SETTING_ORDER_QUERY = "CYBERBIZ_SETTING_ORDER_QUERY"; // Cyberbiz 訂單查詢
export const CYBERBIZ_CUSTOMER_LEVEL_CHANGE = "CYBERBIZ_CUSTOMER_LEVEL_CHANGE"; // CYBERBIZ 會員等級批量調整（逐筆同步）
export const CYBERBIZ_TAG_LIST_CHANGE = "CYBERBIZ_TAG_LIST_CHANGE"; // CYBERBIZ 標籤批量調整（逐筆同步）

export const PARTNER_MARKETING_EVENT_LIST_VIEW = "PARTNER_MARKETING_EVENT_LIST_VIEW"; // 異業點數合作單位列表
export const PARTNER_MARKETING_EVENT_CREATE = "PARTNER_MARKETING_EVENT_CREATE"; // 異業行銷活動 - 新增
export const PARTNER_MARKETING_EVENT_MODIFY = "PARTNER_MARKETING_EVENT_MODIFY"; // 異業行銷活動 - 修改
export const PARTNER_MARKETING_EVENT_DELETE = "PARTNER_MARKETING_EVENT_DELETE"; // 異業行銷活動 - 刪除
export const PARTNER_MARKETING_PLAN_LIST_VIEW = "PARTNER_MARKETING_PLAN_LIST_VIEW"; // 異業活動方案列表
export const PARTNER_MARKETING_PLAN_CREATE = "PARTNER_MARKETING_PLAN_CREATE"; // 異業活動方案 - 新增
export const PARTNER_MARKETING_PLAN_MODIFY = "PARTNER_MARKETING_PLAN_MODIFY"; // 異業活動方案 - 修改
export const PARTNER_MARKETING_PLAN_DELETE = "PARTNER_MARKETING_PLAN_DELETE"; // 異業活動方案 - 刪除
export const PARTNER_MARKETING_CODE_LIST_VIEW = "PARTNER_MARKETING_CODE_LIST_VIEW"; // 活動序號列表
export const PARTNER_MARKETING_CODE_CREATE = "PARTNER_MARKETING_CODE_CREATE"; // 異業活動序號 - 新增
export const PARTNER_MARKETING_CODE_MODIFY = "PARTNER_MARKETING_CODE_MODIFY"; // 異業活動序號 - 修改
export const PARTNER_MARKETING_CODE_DELETE = "PARTNER_MARKETING_CODE_DELETE"; // 異業活動序號 - 刪除
export const LINE_PUSHED_MESSAGES_LIST_VIEW = "LINE_PUSHED_MESSAGES_LIST_VIEW"; // LINE 推播紀錄列表
export const BRANCH_REGISTER_URL_EXPORT = "BRANCH_REGISTER_URL_EXPORT"; // 匯出分店註冊 QRCode
export const BRANCH_TO_OA_URL_EXPORT = "BRANCH_TO_OA_URL_EXPORT"; // 匯出分店轉導 OA QRCode
export const BRANCH_PRODUCT_SINGLE_SYNC = "BRANCH_PRODUCT_SINGLE_SYNC"; // 銷售應用中心 - 分店商品
export const ORGANIZATION_MODULE_LIST_VIEW = "ORGANIZATION_MODULE_LIST_VIEW"; // 全模組列表
export const ORGANIZATION_MODULE_CREATE = "ORGANIZATION_MODULE_CREATE"; // 全系統模組 - 建立
export const ORGANIZATION_MODULE_MODIFY = "ORGANIZATION_MODULE_MODIFY"; // 全系統模組 - 修改
export const ORGANIZATION_MODULE_DELETE = "ORGANIZATION_MODULE_DELETE"; // 全系統模組 - 刪除
export const LUSH_SETTING_QUERY = "LUSH_SETTING_QUERY"; // lush 查詢會員
export const ORDER_QUERY_EXPORT = "ORDER_QUERY_EXPORT"; // 營運資料中心 - 訂單資料查詢與匯出
export const CUSTOMER_QUERY_EXPORT = "CUSTOMER_QUERY_EXPORT"; // 營運資料中心 - 會員名單查詢與匯出

export const TARGET_SOURCE = {
  WALTILY  : 'waltily',  // 一般優惠券
}

export const DISCOUNT_TYPE = {
  PERCENTAGE    : 'percentage',    // 折扣%數
  AMOUNT        : 'amount',        // 折扣金額
  FREE_SHIPPING : 'free_shipping', // 免運
}
